import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface DragDropError {
  file: File | null;
  isInvalid: boolean;
  isValid: boolean;
}

@Directive({
  selector: '[mdDragDrop]',
  exportAs: 'mdDragDrop',
})
export class DragDropDirective {
  @Input() pattern = 'image/*';
  @Input() canRead = true;

  @Output()
  dropHandler: EventEmitter<File | null> = new EventEmitter<File | null>();
  @Output() readHandler: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  errorHandler: EventEmitter<DragDropError> = new EventEmitter<DragDropError>();

  // @ts-expect-error
  dragging: boolean;
  // @ts-expect-error
  loaded: boolean;
  // @ts-expect-error
  imageSrc: string;
  // @ts-expect-error
  invalidFlag: boolean;

  @HostListener('dragover')
  onDragOver() {
    return false;
  }

  @HostListener('dragenter')
  handleDragEnter() {
    this.dragging = true;
  }

  @HostListener('dragleave')
  handleDragLeave() {
    this.dragging = false;
  }

  @HostListener('drop', ['$event'])
  handleDrop(e: { preventDefault: () => void }) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleInputChange(e: { preventDefault?: () => void; dataTransfer?: any }) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : null;

    this.invalidFlag = false;

    if (!file.type.match(this.pattern)) {
      this.invalidFlag = true;
      return this.errorHandler.emit({
        file,
        isInvalid: this.invalidFlag,
        isValid: !this.invalidFlag,
      });
    }

    this.dropHandler.emit(file);
    this.readFile(file);
  }

  handleReaderLoaded(e: any) {
    const reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
    this.readHandler.emit(this.imageSrc);
  }

  readFile(file: File) {
    if (!file || !this.canRead) {
      return;
    }

    const reader = new FileReader();
    this.loaded = false;
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
}
